export default __webpack_public_path__ + "static/media/japreece.f1056aac.png";